import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Card, Modal, Fade } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import CloseIcon from '@mui/icons-material/Close';
import Loading from '../components/Loading'; // Adjust the import based on your project structure

const Players = () => {
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [loading, setLoading] = useState(false);

  const players = [
    {
      name: 'Sudip',
      position: 'ST',
      number: Math.round((85 + 90 + 78 + 80 + 30 + 75) / 6),
      image: '/players/sudip_pandey_9 Background Removed.png',
      pac: 85,
      sho: 90,
      pas: 78,
      dri: 80,
      def: 30,
      phy: 75,
      transform: 'scale(1.6)',
    },
    {
      name: 'Harjeet',
      position: 'CB',
      number: Math.round((75 + 70 + 80 + 65 + 85 + 82) / 6),
      image: '/players/harjeet_shrestha_4 Background Removed.png',
      pac: 75,
      sho: 70,
      pas: 80,
      dri: 65,
      def: 85,
      phy: 82,
      transform: 'scale(1.4)',
    },
    {
      name: 'Himal',
      position: 'CB',
      number: Math.round((85 + 80 + 80 + 80 + 85 + 75) / 6),
      image: '/players/himal_yogi_2 Background Removed.png',
      pac: 85,
      sho: 80,
      pas: 80,
      dri: 80,
      def: 85,
      phy: 75,
      transform: 'scale(1.5)',
    },
    {
      name: 'Niraj',
      position: 'GK',
      number: Math.round((50 + 70 + 70 + 65 + 90 + 80) / 6),
      image: '/players/niraj_1 Background Removed.png',
      pac: 50,
      sho: 70,
      pas: 70,
      dri: 65,
      def: 90,
      phy: 80,
      transform: 'scale(1.6)',
    },
    // {
    //   name: 'Aayush',
    //   position: 'ST',
    //   number: Math.round((78 + 82 + 75 + 80 + 45 + 70) / 6),
    //   image: '/players/aayush_kafle_21 Background Removed.png',
    //   pac: 78,
    //   sho: 82,
    //   pas: 75,
    //   dri: 80,
    //   def: 45,
    //   phy: 70,
    //   transform: 'scale(1.6)',
    // },
    {
      name: 'Samir',
      position: 'LB',
      number: Math.round((72 + 68 + 70 + 78 + 65 + 72) / 6),
      image: '/players/samir_koirala_18 Background Removed.png',
      pac: 72,
      sho: 68,
      pas: 70,
      dri: 78,
      def: 65,
      phy: 72,
      transform: 'scale(1.6)',
    },
    {
      name: 'Rupesh',
      position: 'RB',
      number: Math.round((70 + 80 + 85 + 80 + 85 + 80) / 6),
      image: '/players/rupesh_basnet_5 Background Removed.png',
      pac: 70,
      sho: 80,
      pas: 85,
      dri: 80,
      def: 85,
      phy: 80,
      transform: 'scale(1.5)',
    },
    {
      name: 'Mohan',
      position: 'RM',
      number: Math.round((85 + 80 + 80 + 82 + 75 + 80) / 6),
      image: '/players/mohan_gurung_7 Background Removed.png',
      pac: 85,
      sho: 80,
      pas: 80,
      dri: 82,
      def: 75,
      phy: 80,
      transform: 'scale(1.6)',
    },
    {
      name: 'Bigyan',
      position: 'RM',
      number: Math.round((80 + 85 + 78 + 85 + 70 + 75) / 6),
      image: '/players/bigyan_kharel_8 Background Removed.png',
      pac: 80,
      sho: 85,
      pas: 78,
      dri: 85,
      def: 70,
      phy: 75,
      transform: 'scale(1.5)',
    },
    {
      name: 'Mabin',
      position: 'CB',
      number: Math.round((75 + 80 + 78 + 70 + 60 + 70) / 6),
      image: '/players/mabin_rai_6 Background Removed.png',
      pac: 75,
      sho: 80,
      pas: 78,
      dri: 70,
      def: 60,
      phy: 70,
      transform: 'scale(1.5)',
    },
    {
      name: 'Saubhagya',
      position: 'LM',
      number: Math.round((65 + 70 + 85 + 80 + 75 + 80) / 6),
      image: '/players/saubhagya_basyal_3 Background Removed.png',
      pac: 65,
      sho: 70,
      pas: 85,
      dri: 80,
      def: 75,
      phy: 80,
      transform: 'scale(1.4)',
    },
    {
      name: 'Bishal',
      position: 'GK',
      number: Math.round((70 + 70 + 76 + 70 + 70 + 70) / 6),
      image: '/players/bishal_gyawali_1 Background Removed.png',
      pac: 70,
      sho: 70,
      pas: 76,
      dri: 70,
      def: 70,
      phy: 70,
      transform: 'scale(1.4)',
    },
    {
      name: 'Ronak',
      position: 'CM',
      number: Math.round((85 + 90 + 82 + 88 + 85 + 85) / 6),
      image: '/players/ronak_timilsina_10 Background Removed.png',
      pac: 85,
      sho: 90,
      pas: 82,
      dri: 88,
      def: 85,
      phy: 85,
      transform: 'scale(1.5)',
    },
    {
      name: 'Bigyan',
      position: 'LM',
      number: Math.round((82 + 85 + 80 + 85 + 70 + 75) / 6),
      image: '/players/bigyan_gautam_17 Background Removed.png',
      pac: 82,
      sho: 85,
      pas: 80,
      dri: 85,
      def: 70,
      phy: 75,
      transform: 'scale(1.6)',
    },
    {
      name: 'Prashant',
      position: 'CDM',
      number: Math.round((74 + 75 + 80 + 85 + 85 + 70) / 6),
      image: '/players/prashant_shah_6 Background Removed.png',
      pac: 74,
      sho: 75,
      pas: 80,
      dri: 85,
      def: 85,
      phy: 70,
      transform: 'scale(1.8)',
    },
    {
      name: 'Pamit',
      position: 'CDM',
      number: Math.round((80 + 85 + 78 + 82 + 40 + 75) / 6),
      image: '/players/pamit_adhikari_21 Background Removed.png',
      pac: 80,
      sho: 85,
      pas: 78,
      dri: 82,
      def: 40,
      phy: 75,
      transform: 'scale(1.6)',
    },
  ];

  const handleTouchStart = e => {
    setTouchStart({ x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY });
  };

  const handleTouchMove = e => {
    setTouchEnd({ x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY });
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distanceX = touchStart.x - touchEnd.x;
    const distanceY = touchStart.y - touchEnd.y;
    const isSwipe = Math.abs(distanceX) > 50 || Math.abs(distanceY) > 50;
    if (isSwipe) {
      setSelectedPlayer(null);
    }
  };

  const fetchPlayerData = async () => {
    setLoading(true);
    try {
      // Your data fetching logic here
      // For example: const response = await fetch('/api/players');
      // Wait for a small delay to simulate data fetching if needed
      await new Promise(resolve => setTimeout(resolve, 1000));
    } catch (error) {
      console.error('Error fetching player data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlayerData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Players - Mirmire</title>
        <meta name="description" content="Meet the players of Mirmire" />
        <style>{`body { background-image: url('/gallery/DSC05629.jpg'); background-size: cover; background-position: center; }`}</style>
      </Helmet>

      {/* Loading overlay */}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: 9999,
            backdropFilter: 'blur(5px)',
          }}
        >
          <Loading />
        </Box>
      )}

      {/* Header Section */}
      <Box
        sx={{
          bgcolor: 'black',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: '#FFD700',
            fontWeight: 700,
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            textAlign: 'center',
          }}
        >
          PLAYERS
        </Typography>
      </Box>

      {/* Players Grid Section */}
      <Box
        sx={{
          bgcolor: '#FFFFFF',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '1000px',
            px: 2,
          }}
        >
          <Grid container spacing={4} justifyContent="center">
            {players.map((player, index) => (
              <Grid item xs={12} sm={6} md={4} key={index} display="flex" justifyContent="center">
                <Box
                  className="card-container"
                  sx={{
                    perspective: '1000px',
                    width: '300px',
                    height: '485px',
                  }}
                >
                  <Box
                    className="card-flip"
                    sx={{
                      position: 'relative',
                      width: '100%',
                      height: '100%',
                      transformStyle: 'preserve-3d',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'scale(1.1)',
                      },
                    }}
                  >
                    <Card
                      className="fut-player-card"
                      sx={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        backfaceVisibility: 'hidden',
                        backgroundImage: 'url(/players/card_bg.png)',
                        backgroundColor: 'transparent',
                        backgroundPosition: 'center center',
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat',
                        padding: '3.8rem 1.2rem',
                        boxShadow: 'none',
                        '@media (min-width: 2000px)': {
                          padding: '2.8rem 1.2rem',
                        },
                      }}
                      onClick={() => setSelectedPlayer(player)}
                    >
                      <Box
                        className="player-card-top"
                        sx={{
                          position: 'relative',
                          display: 'flex',
                          color: '#e9cc74',
                          padding: '0 1.5rem',
                          '@media (min-width: 2000px)': {
                            padding: '0 1.0rem',
                          },
                        }}
                      >
                        <Box
                          className="player-master-info"
                          sx={{
                            position: 'absolute',
                            lineHeight: '2.2rem',
                            fontWeight: 300,
                            padding: '1.5rem 0',
                            textTransform: 'uppercase',
                            textAlign: 'left',
                            width: '50%',
                          }}
                        >
                          <Box className="player-rating" sx={{ fontSize: '2rem' }}>
                            {player.number}
                          </Box>
                          <Box
                            className="player-position"
                            sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}
                          >
                            {player.position}
                          </Box>
                        </Box>
                        <Box
                          className="player-picture"
                          sx={{
                            width: '150px',
                            height: '150px',
                            margin: '0 auto',
                            overflow: 'hidden',
                            borderRadius: '20%',
                            transition: 'transform 0.3s ease-in-out',
                            '&:hover': { transform: 'scale(1.05)' },
                            marginLeft: '2rem',
                          }}
                        >
                          <img
                            src={player.image}
                            alt={player.name}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              objectPosition: 'center center',
                              transform: player.transform,
                            }}
                            loading="lazy"
                          />
                        </Box>
                      </Box>
                      <Box
                        className="player-card-bottom"
                        sx={{ position: 'relative', textAlign: 'center' }}
                      >
                        <Box
                          className="player-name"
                          sx={{
                            width: '100%',
                            display: 'block',
                            textAlign: 'center',
                            fontSize: '1.3rem',
                            textTransform: 'uppercase',
                            borderBottom: '2px solid rgba(233, 204, 116, 0.1)',
                            paddingBottom: '0.3rem',
                            overflow: 'hidden',
                            color: '#e9cc74',
                            marginTop: '5px',
                          }}
                        >
                          <span>{player.name}</span>
                        </Box>
                        <Box
                          className="player-attributes"
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: 2,
                            mt: 2,
                            position: 'relative',
                            '&::before': {
                              content: '""',
                              position: 'absolute',
                              top: 0,
                              bottom: 0,
                              left: '50%',
                              width: '1px',
                              bgcolor: 'rgba(233, 204, 116, 0.1)',
                              transform: 'translateX(-50%)',
                            },
                          }}
                        >
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: '1.2rem', color: '#e9cc74', fontWeight: 'bold' }}
                            >
                              {player.pac}{' '}
                              <span style={{ color: '#e9cc74', fontWeight: 'normal' }}>PAC</span>
                            </Typography>
                          </Box>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: '1.2rem', color: '#e9cc74', fontWeight: 'bold' }}
                            >
                              {player.dri}{' '}
                              <span style={{ color: '#e9cc74', fontWeight: 'normal' }}>DRI</span>
                            </Typography>
                          </Box>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: '1.2rem', color: '#e9cc74', fontWeight: 'bold' }}
                            >
                              {player.sho}{' '}
                              <span style={{ color: '#e9cc74', fontWeight: 'normal' }}>SHO</span>
                            </Typography>
                          </Box>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: '1.2rem', color: '#e9cc74', fontWeight: 'bold' }}
                            >
                              {player.pas}{' '}
                              <span style={{ color: '#e9cc74', fontWeight: 'normal' }}>PAS</span>
                            </Typography>
                          </Box>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: '1.2rem', color: '#e9cc74', fontWeight: 'bold' }}
                            >
                              {player.def}{' '}
                              <span style={{ color: '#e9cc74', fontWeight: 'normal' }}>DEF</span>
                            </Typography>
                          </Box>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: '1.2rem', color: '#e9cc74', fontWeight: 'bold' }}
                            >
                              {player.phy}{' '}
                              <span style={{ color: '#e9cc74', fontWeight: 'normal' }}>PHY</span>
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Card>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>

      {/* Player Image Modal */}
      <Modal
        open={!!selectedPlayer}
        onClose={() => setSelectedPlayer(null)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Fade in={!!selectedPlayer} timeout={300}>
          <Box
            sx={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90vh',
              outline: 'none',
              animation: 'zoomIn 0.3s ease-in-out',
              '@keyframes zoomIn': {
                '0%': {
                  opacity: 0,
                  transform: 'scale(0.8)',
                },
                '100%': {
                  opacity: 1,
                  transform: 'scale(1)',
                },
              },
            }}
            onTouchStart={e => handleTouchStart(e)}
            onTouchMove={e => handleTouchMove(e)}
            onTouchEnd={() => handleTouchEnd()}
          >
            {selectedPlayer && (
              <>
                <Box
                  sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    cursor: 'pointer',
                    zIndex: 1,
                  }}
                  onClick={() => setSelectedPlayer(null)}
                >
                  <CloseIcon sx={{ color: '#fff', fontSize: '2rem' }} />
                </Box>
                <img
                  src={selectedPlayer.image}
                  alt={selectedPlayer.name}
                  style={{
                    width: '100%',
                    height: 'auto',
                    maxHeight: '90vh',
                    objectFit: 'contain',
                  }}
                />
              </>
            )}
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default Players;
